/**
 * 键盘输入组件的事件定义
 */

export const KeyboardInputEmits = [
  /** 输入内容变化时触发，参数为输入值 */
  'input',

  /** 输入框获得焦点时触发 */
  'focus',

  /** 输入框失去焦点时触发 */
  'blur',

  /** 点击键盘确认按钮时触发 */
  'confirm',

  /** 双向绑定值更新时触发，用于v-model */
  'update:value',
];
